import React from "react"
import { RowWrapper } from "../Components"
import Paragraph from "../Paragraph"

const Row = ({ data, left, imageLoadPriority = false }) => {
	return (
		<RowWrapper $left={left} className="row">
			{data.map((item, index) => (
				<Paragraph
					key={`${item.text}-${index}`}
					index={index}
					text={item.text}
					left={left}
					imageLoadPriority={imageLoadPriority}
					breakId={item.breakId}
				/>
			))}
		</RowWrapper>
	)
}

export default Row
